var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefreshBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-refresh-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-71.000000, -116.000000)",
    fill: "#9BBFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-refresh-blue",
    transform: "translate(71.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62501265,4.38378603 L2.36251265,4.38378603 C4.02259665,1.83249303 7.16270265,0.676502028 10.0807837,1.54240103 C12.9988647,2.40830103 15.0002067,5.08994303 15.0000127,8.13378603 L16.250021,8.13378603 C16.2535387,4.70911303 14.1093177,1.64991503 10.8888727,0.484954028 C7.66842765,-0.680006972 4.06327865,0.299419028 1.87501265,2.93378603 L1.87501265,0.633786028 L0.625012654,0.633786028 L0.625012654,5.63378603 L5.62501265,5.63378603 L5.62501265,4.38378603 Z M10.6250127,11.883786 L13.8875127,11.883786 C12.2274287,14.435079 9.08732265,15.59107 6.16924165,14.725171 C3.25116065,13.859271 1.24981865,11.177629 1.25001265,8.13378603 L4.32164029e-06,8.13378603 C-0.00351334608,11.558459 2.14070765,14.617657 5.36115265,15.782618 C8.58159765,16.947579 12.1867467,15.968153 14.3750127,13.333786 L14.3750127,15.633786 L15.6250127,15.633786 L15.6250127,10.633786 L10.6250127,10.633786 L10.6250127,11.883786 Z",
    id: "Fill"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshBlue);
export default __webpack_public_path__ + "static/media/icon-refresh-blue.dff23b7daa62d36e86b8a676263f6b12.svg";
export { ForwardRef as ReactComponent };